import React from 'react';
import Icon from '../../../components/AppIcon';

const EarningsPanel = ({ earnings }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2
    })?.format(amount);
  };

  const earningsData = [
    {
      label: 'Aylık Gelir',
      value: earnings?.monthly,
      icon: 'TrendingUp',
      color: 'success',
      change: '+12.5%'
    },
    {
      label: 'Bekleyen Ödemeler',
      value: earnings?.pending,
      icon: 'Clock',
      color: 'warning',
      count: earnings?.pendingCount
    },
    {
      label: 'Toplam Kazanç',
      value: earnings?.total,
      icon: 'DollarSign',
      color: 'primary',
      change: '+28.3%'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Kazanç Özeti</h2>
        <button className="text-sm text-primary hover:text-primary/80 transition-smooth flex items-center gap-1">
          <span>Detaylı Rapor</span>
          <Icon name="ChevronRight" size={16} />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {earningsData?.map((item, index) => (
          <div key={index} className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div className={`
                w-10 h-10 rounded-full flex items-center justify-center
                ${item?.color === 'success' ? 'bg-success/10' : ''}
                ${item?.color === 'warning' ? 'bg-warning/10' : ''}
                ${item?.color === 'primary' ? 'bg-primary/10' : ''}
              `}>
                <Icon 
                  name={item?.icon} 
                  size={20}
                  color={
                    item?.color === 'success' ? 'var(--color-success)' :
                    item?.color === 'warning' ? 'var(--color-warning)' :
                    'var(--color-primary)'
                  }
                />
              </div>
              {item?.change && (
                <span className="text-xs font-medium text-success">{item?.change}</span>
              )}
            </div>
            <p className="text-sm text-muted-foreground mb-1">{item?.label}</p>
            <p className="text-2xl font-bold text-foreground">{formatCurrency(item?.value)}</p>
            {item?.count && (
              <p className="text-xs text-muted-foreground mt-1">{item?.count} ödeme</p>
            )}
          </div>
        ))}
      </div>
      <div className="border-t border-border pt-4">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-muted-foreground">Platform Komisyonu (15%)</span>
          <span className="text-sm font-medium text-foreground">{formatCurrency(earnings?.commission)}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-foreground">Net Kazanç</span>
          <span className="text-lg font-bold text-primary">{formatCurrency(earnings?.net)}</span>
        </div>
      </div>
    </div>
  );
};

export default EarningsPanel;